import harvistLogo from 'assets/img/logo-light.png';
import React from 'react';

import { normalizeAgents } from 'components/AgentLanding/AgentLandingPrimitives';

const PhoneIcon = () => (
  <svg aria-hidden="true" width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.75 19.75 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.75 19.75 0 0 1 2.12 4.18 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.69 2.8a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.28-1.28a2 2 0 0 1 2.11-.45c.9.33 1.84.56 2.8.69A2 2 0 0 1 22 16.92z" />
  </svg>
);

const EmailIcon = () => (
  <svg aria-hidden="true" width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="5" width="18" height="14" rx="2" />
    <path d="m3 7 9 6 9-6" />
  </svg>
);

const WebsiteIcon = () => (
  <svg aria-hidden="true" width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="9" />
    <path d="M3 12h18M12 3a15 15 0 0 1 0 18M12 3a15 15 0 0 0 0 18" />
  </svg>
);

const LicenseIcon = () => (
  <svg aria-hidden="true" width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M6 3h9l3 3v15H6z" />
    <path d="M15 3v4h4M9 12h6M9 16h5" />
  </svg>
);

const AgentLandingFooter = ({ agentData }) => {
  const agents = normalizeAgents(agentData);
  const brandLogo = agentData?.teamLogoUrl || agentData?.companyLogoUrl;
  const brandName = agentData?.companyName || `${agents[0]?.firstName || 'Local'} Real Estate`;

  return (
    <footer className={`al-site-footer ${agents.length === 1 ? 'al-site-footer--single' : 'al-site-footer--team'}`}>
      <div className="al-shell">
        <div className="al-footer-top">
          <div className="al-footer-brand">
            {brandLogo && <img src={brandLogo} alt={brandName} />}
            <p>Thoughtful guidance for confident real estate decisions.</p>
          </div>
          <div className={`al-footer-agents${agents.length === 1 ? ' al-footer-agents--single' : ''}`}>
            {agents.map((agent) => (
              <section className="al-footer-card" key={`${agent.firstName}-${agent.lastName}`}>
                {agent.pictureUrl ? (
                  <img
                    className="al-footer-portrait"
                    src={agent.pictureUrl}
                    alt={`Portrait of ${agent.firstName} ${agent.lastName || ''}`.trim()}
                  />
                ) : (
                  <span className="al-footer-portrait al-agent-fallback" aria-hidden="true">
                    {agent.firstName.charAt(0)}
                    {agent.lastName?.charAt(0)}
                  </span>
                )}
                <div className="al-footer-agent-copy">
                  <span className="al-footer-advisor-label">Your local advisor</span>
                  <h3>
                    {agent.firstName}
                    {' '}
                    {agent.lastName}
                  </h3>
                  <p className="al-footer-role">Real Estate Agent · Local market advisor</p>
                  <ul className="al-footer-details">
                    {agent.phoneNumber && (
                      <li>
                        <PhoneIcon />
                        <a href={`tel:${agent.phoneNumber}`}>{agent.phoneNumber}</a>
                      </li>
                    )}
                    {agent.email && (
                      <li>
                        <EmailIcon />
                        <a href={`mailto:${agent.email}`}>{agent.email}</a>
                      </li>
                    )}
                    {agent.website && (
                      <li>
                        <WebsiteIcon />
                        <a href={agent.website} target="_blank" rel="noreferrer">{agent.website.replace(/^https?:\/\//, '')}</a>
                      </li>
                    )}
                    {agent.licenseNumber && (
                      <li>
                        <LicenseIcon />
                        <span>
                          DRE #
                          {agent.licenseNumber}
                        </span>
                      </li>
                    )}
                  </ul>
                </div>
              </section>
            ))}
          </div>
        </div>
        <div className="al-footer-bottom">
          <span>
            ©
            {new Date().getFullYear()}
            {' '}
            {brandName}
            . All rights reserved.
          </span>
          <span className="al-powered">
            <span>Powered by</span>
            <a
              href="https://harvist.com/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Visit Harvist"
            >
              <img src={harvistLogo} alt="Harvist" />
            </a>
          </span>
        </div>
      </div>
    </footer>
  );
};

export default AgentLandingFooter;
